<form
    [formGroup]="variantsForm"
    #ngForm="ngForm"
    name="beltkit-product-selector"
    class="product-selector"
    [attr.method]="'post'">
    <span
        role="heading"
        i18n-role
        aria-level="3"
        hSrOnlyNoSnippet
        i18n="@@hermes.accessibility.product-customizer-title">
        Customization and add to cart
    </span>

    <!-- selector header -->
    <div class="product-selector-header">
        <h-product-info-header [product]="product" [showPrice]="false"></h-product-info-header>
        <!-- Image for desktop -->
        <span
            id="product-info"
            hSrOnlyNoSnippet
            role="heading"
            i18n-role
            aria-level="2"
            i18n="@@hermes.commerce.product_locator.product_information.label">
            Product information
        </span>
    </div>

    <p class="product-price paragraph-medium">
        <span [attr.aria-live]="'polite'" [attr.aria-atomic]="false">
            <h-price
                [price]="product.price"
                [size]="'medium'"
                [format]="'short'"
                [weight]="'bold'"
                [hasPrimaryColor]="false">
            </h-price>
        </span>
        @if (product.unitPrice && product.unitPriceDesc) {
        <span class="product-unit-price"
            >(<h-price [price]="product.unitPrice" [size]="'small'" [format]="'short'"></h-price>
            {{ product.unitPriceDesc }})
        </span>
        }
    </p>

    <!-- selector content -->
    <h-variant-template
        #sizeToggle
        [selectedProductVariant]="selectedProductVariant"
        [product]="product"
        [variantsForm]="variantsForm"
        [hideSizeAlert]="hideSizeAlert"
        [findInStorePressed]="findInStorePressed"></h-variant-template>

    <!-- selector footer -->
    <div class="product-selector-footer">
        <h-call-to-action-purchase
            [product]="product"
            [transparentBackground]="true"
            [buttonsPosition]="'row'"
            [border]="false"
            (addToCart)="addToCartAction($event)">
        </h-call-to-action-purchase>
        @if (product.stock?.retail) {
        <h-call-to-action-find-in-store
            [skus]="[selectedProductVariant.buckle?.skuBuckle ?? '', selectedProductVariant.leather?.skuLeather ?? '']"
            [product]="product"
            [hasBorder]="false"
            [hasPadding]="false"
            [shouldPreventProductLocatorLaunch]="shouldPreventProductLocatorLaunch()"
            [transparentBackground]="true"
            (pressed)="findInStoreAction()">
        </h-call-to-action-find-in-store>
        }
    </div>
</form>
